import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../../../common/EditPage';
import Panel from '../../../../../common/layout/Panel'
import { getOne, create } from './../../../../../common/v4/BackendProvider';
import { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const VoiceRateItemCreate = (props) => {

    const [data, setData] = useState({
        'prefix': '',
        'description': '',
        'rate': '0.00',
        'connection_fee': '0.00',
        'min_duration': '1',
        'increment': '1',
        'currency_id': '',
        'enabled': true,
    });
    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { rate_id } = useParams();
    useEffect(() => {
        getOne(`/admin/products/voice/rates/${rate_id}/items/`, 'new')
            .then(response => {
                setMetadata(response.data.metadata);
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });
    }, []);

    const handleSave = () => {
        create(`/admin/products/voice/rates/${rate_id}/items/`, {data: data})
            .then(response => {
                toast.success('Voice Rate Item created successfully');
                navigate(`/products/voice/rates/${rate_id}`);
            }).catch(error => {
                toast.error('Error creating voice rate item: ' + error.message);
            });
    }

    const handleCancel = () => {
        navigate(`/products/voice/rates/${rate_id}`);
    }

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    }

    return (<> 
        <Panel title = "Voice Rate Items">
            <div>
                <ToastContainer />
                <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Voice Rate Item">
                    <EditPagePanel>
                        <EditPageTextField label="Prefix" nullable id="prefix" onChange={ onChange } value={ data.prefix } />
                        <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                        <EditPageTextField label="Rate" id="rate" onChange={ onChange } value={ data.rate } />
                        <EditPageTextField label="Connection Fee" id="connection_fee" onChange={ onChange } value={ data.connection_fee } />
                        <EditPageTextField label="Min Duration" id="min_duration" onChange={ onChange } value={ data.min_duration } />
                        <EditPageTextField label="Increment" id="increment" onChange={ onChange } value={ data.increment } />
                        <EditPageSelect label="Currency" id="currency_id" onChange={ onChange } value={ data.currency_id } options={ metadata?.currency_id?.values } />
                        <EditPageCheckbox label="Enabled" id="enabled" onChange={ onChange } value={ data.enabled } />
                    </EditPagePanel>
                </EditPage>
            </div>
        </Panel>
        </>
    )
}

export default VoiceRateItemCreate;